/* types imports */
import type { Actions } from "constants/game";

/**
 * Assign an action to a card, and remove it from the card
 * that had it before, so each action is used only once
 * @param {(Actions | null)[]} choices The current action of each card
 * @param {Actions} action The action picked by the user
 * @param {number} cardIndex The index of the card the action was picked on
 * @returns {(Actions | null)[]} The new action of each card
 */
export const selectChoice = (
  choices: (Actions | null)[],
  action: Actions,
  cardIndex: number
): (Actions | null)[] => {
  return choices.map((choice, index) => {
    return choice === action && index !== cardIndex
      ? null
      : index === cardIndex
        ? action
        : choice;
  });
};

export default { selectChoice };
